var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block__empty"},[_c('div',{staticClass:"content-block__empty-title"},[_vm._v(_vm._s(_vm.$t('header.addMaterialToTheCourse')))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block__empty-image"},[_c('div',{staticClass:"image f-center"},[_c('img',{attrs:{"src":require("@/assets/images/svg/empty-material.svg"),"alt":"Ручка"}})])])
}]

export { render, staticRenderFns }